import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Sidebar from "./Sidebar";
import PageContent from "./PageContent";
import ActionBar from "./ActionBar";
import { Contents } from "../styles";

const propTypes = {
  header: PropTypes.element.isRequired,
  heading: PropTypes.node,
  leftSidebar: PropTypes.element,
  rightSidebar: PropTypes.element,
  actionBar: PropTypes.node,
  content: PropTypes.element.isRequired,
  footer: PropTypes.node,
  transparent: PropTypes.bool,
  showLeftSideBar: PropTypes.bool,
};

function Wrapper({
  header,
  heading,
  leftSidebar,
  actionBar,
  content,
  footer,
  rightSidebar,
  transparent,
  showLeftSideBar,
  marginLeft,
  mainAreaOverflow,
  className,
  noHorizontalMargin
}) {
  return (
    <Contents className={className ? `${className}__ContentsBox`:''} marginLeft={marginLeft}>
      {header}
      <div className={`d-flex h-100`+ (className ? ` ${className}__OuterPageContentDiv `:'')}>
        {showLeftSideBar && leftSidebar}

        {(heading || footer || actionBar || content || rightSidebar) && (
          <PageContent
            noHorizontalMargin={noHorizontalMargin}
            mainAreaOverflow={mainAreaOverflow}
            heading={heading}
            footer={footer}
            transparent={transparent || false}
            className={className}
          >
            {actionBar}
            {content}
          </PageContent>
        )}
      </div>
      {rightSidebar}
    </Contents>
  );
}

Wrapper.propTypes = propTypes;
Wrapper.Header = Header;
Wrapper.Sidebar = Sidebar;
Wrapper.ActionBar = ActionBar;

export default Wrapper;



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/components/Wrapper.js